import { registerMutation, useMutation } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
const UPDATE_COLLECTED_FORMS_NAME_FIELD = 'UPDATE_COLLECTED_FORMS_NAME';
const UPDATE_COLLECTED_FORMS_NAME = registerMutation({
  fieldName: UPDATE_COLLECTED_FORMS_NAME_FIELD,
  args: ['formGuid', 'formName'],
  fetcher({
    formGuid,
    formName
  }) {
    return http.put(`/forms/v2/forms/rename/${formGuid}`, {
      data: {
        name: formName
      }
    });
  }
});
export default function useRenameForm() {
  const [renameForm, {
    loading,
    error
  }] = useMutation(UPDATE_COLLECTED_FORMS_NAME);
  return {
    error,
    loading,
    renameForm: variables => renameForm({
      variables
    })
  };
}